import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import React, { useEffect, useState } from 'react';
import config from '../../../../../config';
import { Customer } from '../../../../entities/impl/blfApi/schemas/customer';
import { User } from '../../../../entities/impl/blfApi/schemas/user';

/**
 * Initialize LaunchDarkly with all necessary contexts.
 * @param user Object containing user information.
 * @param customer Object containing customer information.
 */
export const useInitLaunchDarkly = (
  user?: User | null,
  customer?: Customer | null
) => {
  const [LdProvider, setLdProvider] =
    useState<React.ComponentType<{ children: React.ReactNode }>>();

  useEffect(() => {
    let active = true;
    async function init() {
      if (!user || !customer) {
        return;
      }

      const context = {
        kind: 'multi',
        user: {
          key: user.id,
          name: `${user.firstName} ${user.lastName}`,
          email: user.email,
        },
        customer: {
          key: customer.id,
          name: customer.name,
          shortCode: customer.shortCode,
        },
      } as const;

      const Provider = await asyncWithLDProvider({
        clientSideID: config.launchDarkly.clientId,
        reactOptions: { useCamelCaseFlagKeys: false },
        context,
        timeout: 3,
        options: {
          bootstrap: 'localStorage',
        },
      });

      if (active) {
        setLdProvider(() => Provider);
      }
    }

    init();
    return () => {
      active = false;
    };
  }, [user, customer]);

  return LdProvider;
};
